export interface RouteWithPreviousLocation {
  hash?: string;
  pathname: string;
  search: string;
  state: {
    from: {
      path: string;
      query: string;
    };
  };
}

export interface RouteWithPreviousLocationParams {
  hash?: string;
  search?: string;
  url: string;
}

export const getRouteWithPrevLocation = ({
  url,
  hash,
  search = "",
}: RouteWithPreviousLocationParams): RouteWithPreviousLocation => ({
  pathname: url,
  hash,
  search,
  state: {
    from: {
      path: window.location.pathname,
      query: window.location.search,
    },
  },
});
